import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useEmpresa() {
  const { user } = useAuth();
  const [empresa, setEmpresa] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (!user?.empresa_id) {
      setEmpresa(null);
      setCargando(false);
      return;
    }
    setCargando(true);
    api
      .get("/empresas/mi")
      .then((r) => setEmpresa(r.data))
      .catch(() => setEmpresa(null))
      .finally(() => setCargando(false));
  }, [user?.empresa_id]);

  return { empresa, cargando };
}
